<template>
  <div :class="$style.mdmVideoContainer">
    <WistiaVideo
      :videoUrl="iFrameUrl"
    />
  </div>
</template>

<script>
import { GettingStartedConsts } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import WistiaApi from 'client/GrowthEngineering/WistiaApi';
import WistiaVideo from 'client/GrowthEngineering/components/WistiaVideo.vue';

export default {
  name: 'GettingStartedMdmVideo',

  components: {
    WistiaVideo,
  },

  data: () => ({
    iFrameUrl: GettingStartedConsts.wistiaMdmGettingSetupVideoUrl,
    videoId: GettingStartedConsts.wistiaMdmGettingSetupVideoId,
  }),

  created() {
    this.configureSegmentEvents();
  },

  methods: {
    configureSegmentEvents() {
      WistiaApi.initialize();
      // Triggering a Segment event when the video is played
      WistiaApi.addCustomConfiguration({
        id: this.videoId,
        onReady(video) {
          video.bind('play', () => {
            EventHelper.triggerMdmHomeVideoPlayed();
          });
        },
      });
    },
  },
};
</script>

<style module>
.mdmVideoContainer {
  margin: auto;
}
</style>
